export default {
  会员中心: 'My Account',
  企业云展系统: 'My Company',
  企业云展: 'Company Profile',
  我的云企业: 'Company Profile',
  企业动态: 'Company News',
  我的企业动态: 'Company News',
  企业资料库: 'Company Library',
  客户数据: 'Customer Data',
  子账号管理: 'Employee Accounts',
  展览管理: 'Manage Exhibitions',
  会议管理: 'Manage Conferences',
  头条管理: 'Manage Industry News',
  招标管理: 'Manager Tenders',
  我的展览: 'My Exhibitions',
  参展报名: 'Exhibitor Registration',
  参观报名: 'Visitor Registration',
  展厅搭建报名: 'Booth Construction Application',
  我的会议: 'My Conferences',
  参加报名: 'Registration',
  会议赞助: 'Sponsorship',
  我的直播: 'My Live Streams',
  产品管理: 'Manage Products',
  产品服务: 'Manage Products',
  采购管理: 'Product Orders',
  客户采购单: 'Buyers’ Orders',
  我的采购单: 'My Orders',
  我的采购: 'My Orders',
  订单管理: 'My Purchases',
  发票管理: 'Manage Invoices',
  我的名片: 'My Business Cards',
  我的海报: 'My Posters',
  我的收藏: 'My Saved Items',
  我的钱包: 'My Account',
  基本资料: 'Basic Info',
  消息中心: 'Messages',
  大数据营销: 'Big Data Marketing',
  大数据获客: 'Big Data Marketing',
  短信邀约: 'Domestic Marketing',
  邮件邀约: 'International Marketing',
  精准邀约: 'Precise Invitation',
  通讯录: 'Address Book',
  我的优惠券: 'My Coupons',
  云优惠: 'Cloud Offer',
}
